export default __webpack_public_path__ + "static/media/scansione.3fd273df.png";